export default "__VITE_ASSET__CLzgG43v__"